<!-- //NOSONAR -->
<li class="list-inline-item venture__actions-item">
  <ng-container *ngIf="isLoadingEntity; else copiesBtn">
    <div class="text-center">
      <i class="fas fa-spinner fa-spin"></i>
    </div>
  </ng-container>
  <ng-template #copiesBtn>
    <a
      class="interaction-btn interaction-btn__copy d-flex align-items-center"
      appDebounceClick
      (debounceClick)="toggleCopy()"
    >
      <i class="far fa-copy text-gray-600"></i>

      <span
        class="venture__actions-label text-hide-small font-weight-500 text-gray-600"
      >
        <span *ngIf="!copied; else copiedTemp" translate>{{ 'Copy' }}</span>
        <ng-template #copiedTemp>
          <span class="copied" translate>{{ 'Copied' }}</span>
        </ng-template>
      </span>
    </a>
  </ng-template>
</li>
